/**
 * Desplaza la vista hasta una sección de la home.
 *
 * Reintenta unos instantes porque, al llegar desde otra ruta, la sección puede
 * no estar todavía en el DOM (o su altura aún no ser la definitiva mientras
 * cargan las imágenes) en el momento del primer intento.
 */
export const scrollToSection = (id, { behavior = 'smooth', attempts = 10 } = {}) => {
    if (!id) return;

    let remaining = attempts;

    const attempt = () => {
        const section = document.getElementById(id);

        if (section) {
            section.scrollIntoView({ behavior, block: 'start' });
            return;
        }

        remaining -= 1;
        if (remaining > 0) requestAnimationFrame(attempt);
    };

    requestAnimationFrame(attempt);
};
